import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { thunkFetchAttendeeMaterials } from '@/redux/actions';
import AttendeeMaterialsContent from '../AttendeeMaterials';

const MaterialsPicker = props => {
	const { event, getAttendeeMaterials, library, handlePickItem, from } = props;

	useEffect(() => {
		getAttendeeMaterials(event.id, 'useEffect - MaterialsPicker');
	}, []);

	const materialsToShow = {
		...library,
		libraries: library.libraries.filter(l => !l.hidden),
		media: { nodes: library.media.nodes?.filter(m => !m.hidden) },
	};
	return (
		<AttendeeMaterialsContent
			library={materialsToShow}
			event={event}
			handlePickItem={handlePickItem}
			from={from}
		/>
	);
};

const msp = ({ library }) => ({
	library,
});

const mdp = dispatch => ({
	getAttendeeMaterials: (eventID, from) => dispatch(thunkFetchAttendeeMaterials(eventID, from)),
});

export default connect(msp, mdp)(MaterialsPicker);
